(function (window) {
  'use strict';

  const searchStandalone = document.querySelector('.js-search-standalone');
  const searchInput = document.querySelector('.js-search-standalone-input');
  const searchButton = document.querySelector('.js-search-standalone-button');
  const activeSearchClass = 'js-search-standalone--active';

  function handlePageLoad(e) {
    if (searchInput.value) {
      searchStandalone.classList.add(activeSearchClass);
    }
  }

  function handleSearchInputChange(e) {
    if (e.target.value) {
      searchStandalone.classList.add(activeSearchClass);
    }
    else {
      searchStandalone.classList.remove(activeSearchClass);
    }
  }

  function handleSearchButton(e) {
    if (searchStandalone && searchButton) {
      const searchForm = searchStandalone.querySelector('form');
      const searchIcon = searchButton.querySelector('.icon--search');
      const closeIcon = searchButton.querySelector('.icon--close-large');

      // If the search icon is visible, we submit the form on click.
      if (!isHidden(searchIcon) && searchInput.value) {
        searchForm.submit();
        e.preventDefault();
      }
      // If the close icon is visible, we reset the field on click.
      else if (!isHidden(closeIcon)) {
        // The reset button doesn't trigger an `input` event.
        searchStandalone.classList.remove(activeSearchClass);
        searchInput.value = '';
        searchInput.focus();
        if (typeof componentEvents !== 'undefined') {
          componentEvents.emitEvent('search-standalone-cleared', [{
            searchInput: searchInput,
          }]);
        }
      }
    }
  }

  if (searchStandalone && searchInput && searchButton) {
    window.addEventListener('load', handlePageLoad);
    searchInput.addEventListener('input', handleSearchInputChange);
    searchButton.addEventListener('click', handleSearchButton);
  }

})(this);
